<template>
    <div class="layout cutawayLayout">
        <!-- NAVBAR -->
        <v-slide-y-transition>
            <v-container
                ref="cutawayLayout"
                v-show="!isOpenedSidebar"
                fluid
            >
                <v-row
                    class="text-center"
                    no-gutters
                >
                    <v-col cols="12">
                        <div
                            class="d-flex align-center"
                            :class="!displayFavorite ? 'justify-center' : 'justify-end'"
                        >
                            <!-- SWITCH -->
                            <div
                                v-if="data.lotView === 'both' && !displayFavorite"
                                ref="widget-switch"
                                class="item-menu switch"
                            >
                                <div class="item">
                                    <v-tooltip 
                                        content-class="bottom"
                                        bottom
                                        v-model="showTooltip['plot-grid']"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <a
                                                v-bind="attrs"
                                                v-on="on"
                                                href="#"
                                                class="nav-button"
                                                :class="{ 'widget-selected' : widget === 'plot-grid' }"
                                                @click.prevent="switchWidget('plot-grid')"
                                            >
                                                <i class="icon icon-plot-grid"/>
                                            </a>
                                        </template>
                                        <span>
                                            {{ $t('sidebar.tooltips.plotGrid') }}
                                        </span>
                                    </v-tooltip>
                                </div>
                                <div class="item">
                                    <v-tooltip 
                                        content-class="bottom"
                                        bottom
                                        v-model="showTooltip['3d']"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <a
                                                v-bind="attrs"
                                                v-on="on"
                                                href="#"
                                                class="nav-button"
                                                :class="{ 'widget-selected' : widget === 'cutaway' }"
                                                @click.prevent="switchWidget('cutaway')"
                                            >
                                                <i class="icon icon-3d"/>
                                            </a>
                                        </template>
                                        <span>
                                            {{ $t('sidebar.tooltips.threeDView') }}
                                        </span>
                                    </v-tooltip>
                                </div>
                            </div>

                            <!-- FLOOR -->
                            <div
                                v-if="data.filters.floors && data.filters.floors.length > 1 && !displayFavorite"
                                class="item-menu custom-select"
                                ref="selectFloorParent"
                                @blur=closeFloorSelect()
                                :tabindex="0"
                            >
                                <div
                                    ref="selectFloorTop"
                                    class="selected active"
                                    :class="{ open: selectOpenStatus.floor }"
                                    :style="{ width: isMobileScreen ? '35px' : selectWidth.floor + 'px' }"
                                    @click.prevent="openFloorSelect()"
                                >
                                    <span class="icon icon-pyramid"/>
                                    <span class="nav-text nav-title">
                                        {{ currentFloorTitle }} {{ plotCount }}
                                    </span>
                                    <span
                                        class="arrow-icon"
                                        :class="{ open: selectOpenStatus.floor }"
                                    >
                                        <span class="left-bar"/>
                                        <span class="right-bar"/>
                                    </span>
                                </div>

                                <transition name="slidedown">
                                    <div
                                        v-show="selectOpenStatus.floor"
                                        class="items"
                                        ref="selectFloorBot"
                                    >
                                        <div
                                            v-if="widget === 'cutaway'"
                                            :style="{ width: selectWidth.floor + 'px' }"
                                        >
                                            <div
                                                v-for="(floor, ind) of data.floors"
                                                :key="'floor' + ind"
                                                class="item"
                                                @click="filterByFloor(floor); trackingEventSearching(); closeFloorSelect();"
                                            >
                                                <span
                                                    v-if="floor.id !== currentFloor.id"
                                                    class="nav-text"
                                                >
                                                    {{ floor.text }} {{ showPlotCount ? '(' + floor.hotspots ? floor.hotspots.length : 0 + ')' : '' }}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            v-else
                                            class="items-typology"
                                            :style="{ width: selectWidth.floor + 'px' }"
                                        >
                                            <div
                                                v-for="(floor, ind) of data.filters.floors"
                                                :key="'floor' + ind"
                                                class="item"
                                                :class="{'active': floor.active}"
                                                @click="filterByMultiFloor(floor); trackingEventSearching();"
                                            >
                                                <span
                                                    class="boolet-list"
                                                    :class="{ 'active': floor.active }"
                                                />
                                                <span class="nav-text">
                                                    {{ floor.text }} ({{ floor.hotspots ? floor.hotspots.length : 0 }})
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>

                            <!-- FILTERS BUTTON -->
                            <div
                                v-if="!isReviewUse"
                                class="item-menu custom-select"
                                ref="filter-button"
                                @click.prevent="toggleMenu()"
                            >
                                <div class="selected">
                                    <span class="icon icon-search"/>
                                    <span class="nav-text">
                                        {{ $t("sidebar.filters.showFilters") }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <!-- /NAVBAR -->
        </v-slide-y-transition>

        <!-- SIDEBAR -->
        <div
            id="sidebar"
            class="sidebar"
            :style="{ width: widthSidebar + 'px'}"
        >
            <a
                href="#"
                class="menu-opener"
                @click.prevent="toggleMenu();"
            >
                <span class="menu-opener__wrapper">
                    <span class="menu-opener__text">
                        <span/>
                    </span>
                </span>
            </a>
            <v-card class="mx-auto">
                <v-navigation-drawer
                    app
                    permanent
                    :width="widthSidebar"
                >
                    <v-list
                        ref="sidebar-header"
                        key="sidebar-header"
                    >
                        <v-list-item class="sidebar-header sidebar-header-standalone">
                            <v-list-item-content class="title pa-6 text-center">
                                <h2>
                                    {{ $t('sidebar.filters.filtersTitle') }}
                                </h2>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-list
                        key="sidebar-body"
                        class="sidebar-body"
                    >
                        <v-list-item class="sidebar-section pa-0">
                            <v-sheet
                                id="sidebar-content"
                                class="overflow-y-auto"
                                :maxHeight="sidebarHeight"
                                :width="widthSidebar"
                            >
                                <v-row
                                    v-if="buttonTopVisible"
                                    id="scroll-top"
                                    dense
                                    no-gutters
                                    class="justify-center scroll-cta"
                                >
                                    <v-btn
                                        icon
                                        elevation="0"
                                        @click.prevent="scrollToTop"
                                    >
                                        <v-icon class="icon">
                                            icon-tri-up
                                        </v-icon>
                                    </v-btn>
                                </v-row>

                                <v-row
                                    class="mx-8 my-6"
                                    v-scroll:#sidebar-content="onScroll"
                                >
                                    <v-container class="sidebar-content pb-8">
                                        <!-- PLOT SEARCH -->
                                        <div class="search-block">
                                            <autocomplete
                                                id="gtm-input-plotsearch"
                                                class="habiteo-body-2"
                                                :search="search"
                                                ref="autocomplete"
                                                :placeholder="$t('sidebar.searchBar')"
                                                auto-select
                                                @submit="searchSubmit">
                                            </autocomplete>
                                            <v-icon
                                                v-if="inputSearch == ''"
                                                class="btn-search"
                                            >
                                                icon-glass-search-bar
                                            </v-icon>
                                            <v-icon
                                                v-else
                                                class="btn-search"
                                                @click="resetSearch()"
                                            >
                                                icon-Delete-search-bar
                                            </v-icon>
                                        </div>

                                        <!-- FAVORITES -->
                                        <div class="pt-8">
                                            <v-row class="d-flex align-center">
                                                <v-col cols="12">
                                                    <v-btn
                                                        id="gtm-filter-favorite"
                                                        class="pa-0 justify-start"
                                                        text
                                                        block
                                                        :ripple="false"
                                                        :elevation="0"
                                                        @click.prevent="filterFavorite();"
                                                    >
                                                        <div class="d-flex pa-0">
                                                            <v-icon
                                                                class="pa-0"
                                                                :class="{ 'active active-heart': data.filters.isFavorite }"
                                                            >
                                                                {{ data.filters.isFavorite ? 'icon-heart' : 'icon-empty-heart grey-text text-darken-1'}}
                                                            </v-icon>
                                                            <div class="pa-2">
                                                                <div class="habiteo-body-2 text-left favorite font-weight-bold text-none dark-text">
                                                                    {{ $t('favorite.wishlist') }} ({{ favoritePlotCounter }})
                                                                </div>
                                                                <div class="legend text-none grey-text text-darken-1">
                                                                    {{ $t("favorite.info") }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </div>

                                        <div v-if="useFloorsSelector">
                                            <RadioButton
                                                class="pt-8"
                                                section="floor"
                                                :currentFloor="currentFloor"
                                                :filterData="data.filters.floors"
                                                :orientation="'desc'"
                                                @select-method="selectFloor"
                                            />
                                        </div>

                                        <ResetFiltersButton @reset-method="resetFilters"/>

                                        <!-- TYPOLOGIES -->
                                        <CheckboxFilter
                                            v-if="showTypologiesCheckbox"
                                            filterType="typology"
                                            :filterData="data.filters.typologies"
                                            @filter-method="filterByTypology"
                                        />

                                        <!-- PRICES -->
                                        <SliderFilter
                                            v-if="showPriceSlider"
                                            :key="'price'"
                                            :sliderType="data.program.investType === 'rent' ? 'rent' : 'price'"
                                            :min="data.filters.priceInterval.min"
                                            :max="data.filters.priceInterval.max"
                                            :userFilter="data.filters.userPriceInterval"
                                            @filter-method="filterByPrice"
                                        />

                                        <!-- AREA -->
                                        <SliderFilter
                                            v-if="showAreaSlider"
                                            key="area"
                                            sliderType="area"
                                            :areaUnit="data.areaUnit"
                                            :min="data.filters.areaInterval[data.areaUnit].min"
                                            :max="data.filters.areaInterval[data.areaUnit].max"
                                            :userFilter="data.filters.userAreaInterval"
                                            @filter-method="filterByArea"
                                        />

                                        <!-- LEVELS -->
                                        <CheckboxFilter
                                            v-if="useFloorFilter"
                                            key="floors"
                                            filterType="floor"
                                            :filterData="data.filters.floors"
                                            @filter-method="filterByFloor"
                                        />

                                        <!-- AVAILABILITIES -->
                                        <CheckboxFilter
                                            v-if="showAvailabilitiesCheckbox"
                                            key="availabilities"
                                            filterType="availability"
                                            :filterData="data.filters.availabilities"
                                            @filter-method="filterByAvailability"
                                        />

                                        <!-- TAGS -->
                                        <CheckboxFilter
                                            v-if="showTagsCheckbox"
                                            key="tags"
                                            filterType="tag"
                                            :filterData="data.filters.tags"
                                            @filter-method="filterTag"
                                        />
                                    </v-container>
                                </v-row>

                                <v-row
                                    v-if="buttonBottomVisible"
                                    id="scroll-bottom"
                                    dense
                                    no-gutters
                                    class="justify-center scroll-cta"
                                >
                                    <v-btn
                                        icon
                                        elevation="0"
                                        @click.prevent="scrollToBottom"
                                    >
                                        <v-icon class="icon">
                                            icon-tri-down
                                        </v-icon>
                                    </v-btn>
                                </v-row>
                            </v-sheet>
                        </v-list-item>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </div>
        <!-- /SIDEBAR -->

        <ShareFavorite
            v-if="displayFavorite && widget === 'plot-grid'"
            class="share-favorite"
            :widget="widget"
        />
    </div>
</template>

<script>
    import _ from "lodash";
    import { EventBus } from '@/event-bus';
    import { debounce } from 'lodash';
    import { mapActions, mapGetters } from 'vuex';

    import Autocomplete from "@trevoreyre/autocomplete-vue";
    import CheckboxFilter from "@/components/sidebar/cutaway/components/CheckboxFilter";
    import SliderFilter from "@/components/sidebar/cutaway/components/SliderFilter";
    import RadioButton from "@/components/sidebar/cutaway/components/RadioButton";
    import ResetFiltersButton from '@/components/sidebar/cutaway/components/ResetFiltersButton';
    import ShareFavorite from '@/components/cutawayHeader/components/ShareFavorite';

    export default {
        name: 'CutawayLayout',
        components: {
            RadioButton,
            SliderFilter,
            CheckboxFilter,
            Autocomplete,
            ResetFiltersButton,
            ShareFavorite
        },
        props: [
            'data',
            'widthSidebar',
            'isOpenedProgramInfo',
            'isOpenedSidebar'
        ],
        data() {
            return ({
                selectOpenStatus: {
                    floor: false
                },
                selectWidth: {
                    floor: null
                },
                widget: 'cutaway',
                defaultFilters: null,
                isPriceSliderReady: false,
                isFavorite: false,
                clickedTracking: false,
                inputSearch: "",
                showTooltip: {
                    'plot-grid': false,
                    '3d': false
                },
                tooltipDuration: 3000,
                tooltipTimeout: null,
                sidebarHeight: null,
                scrollValue: 0,
                scrollMax: 0,
                plotFavList: []
            });
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable',
                'isReviewUse',
                'protocol'
            ]),
            ...mapGetters('widget', [
                'displayFavorite',
                'showPlotCount'
            ]),
            currentFloorTitle() {
                return this.widget === 'cutaway' ? this.data.floors[this.currentFloor].text : this.$t("sidebar.filters.floor");
            },
            plotCount() {
              return this.showPlotCount ? '(' + (this.data.floors[this.currentFloor].hotspots ? this.data.floors[this.currentFloor].hotspots.length : 0) + ')' : '';
            },
            currentFloor() {
                return this.$props.data.floors ? this.$props.data.floors.findIndex(floor => floor.active) : null;
            },
            favoriteKey() {
                return `favorite-${this.programUuid}`;
            },
            programUuid() {
                return this.$props.data ? this.$props.data.program.id : null;
            },
            useFloorFilter() {
                return this.$props.data.filters.floors && this.$props.data.filters.floors.length > 1 && this.widget === 'plot-grid';
            },
            useFloorsSelector() {
                return this.$props.data.filters.floors && this.$props.data.filters.floors.length > 1 && this.widget === 'cutaway';
            },
            showTypologiesCheckbox() {
                return this.$props.data.filters.typologies && Object.keys(this.$props.data.filters.typologies).length > 0;
            },
            showAvailabilitiesCheckbox() {
               return this.$props.data.filters.availabilities && Object.keys(this.$props.data.filters.availabilities).length > 0;
            },
            showTagsCheckbox() {
                return this.$props.data.filters.tags && this.$props.data.filters.tags.length > 0;
            },
            showPriceSlider() {
                return this.$props.data.filters.priceInterval && this.$props.data.filters.priceInterval.min !== null && (this.$props.data.filters.priceInterval.max !== null && this.$props.data.filters.priceInterval.max !== 0);
            },
            showAreaSlider() {
                return this.$props.data.filters.areaInterval[this.$props.data.areaUnit] && this.$props.data.filters.areaInterval[this.$props.data.areaUnit].min !== null && (this.$props.data.filters.areaInterval[this.$props.data.areaUnit].max !== null && this.$props.data.filters.areaInterval[this.$props.data.areaUnit].max !== 0);
            },
            buttonTopVisible() {
                return this.scrollValue > 0;
            },
            buttonBottomVisible() {
                return this.scrollValue !== this.scrollMax;
            },
            hasSharedFavlist() {
                return this.$route.query.favlist ? true : false;
            },
            favoriteList: {
                get() {
                    return this.plotFavList;
                },
                set(newValue) {
                    localStorage.setItem(this.favoriteKey, JSON.stringify(newValue));
                    this.plotFavList = JSON.parse(localStorage.getItem(this.favoriteKey));
                }
            },
            favoritePlotCounter() {
                return this.favoriteList.length;
            },
            isMobileScreen() {
                return this.$vuetify.breakpoint.xs;
            },
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.widget = this.$props.data.type;
            this.defaultFilters = _.cloneDeep(this.$props.data.filters);
            this.currentLevel = this.$props.data.floors.findIndex(level => level.active);

            this.handler();
            document.addEventListener('visibilitychange', this.handler);
            window.addEventListener('DOMContentLoaded', this.handler);
            window.addEventListener('resize', debounce(this.handler, 400));

            if (this.isLocalstorageAvailable)
                this.favoriteList = localStorage.getItem(this.favoriteKey) ? JSON.parse(localStorage.getItem(this.favoriteKey)) : [];

            if (this.hasSharedFavlist)
                this.filterFavorite();

            EventBus.$on('setCutawayWidget', widget => this.widget = widget);

            EventBus.$on('updatePlotFavorites', favoriteList => this.favoriteList = favoriteList);

            EventBus.$on('updateFloor', floor => this.getCurrentFloor(floor));
        },
        methods: {
            ...mapActions('widget', [
                'setDisplayFavorite'
            ]),
            getMaxWidth() {
                if (this.$refs.selectFloorBot && this.$props.data.filters.floors && this.$props.data.filters.floors.length > 1) {
                    this.$refs.selectFloorBot.style.display = 'block';
                    let topWidth = this.$refs.selectFloorTop.clientWidth;
                    let botWidth = this.$refs.selectFloorBot.clientWidth;
                    this.$refs.selectFloorBot.style.display = 'none';
                    this.selectWidth.floor = topWidth > botWidth ? topWidth : botWidth;
                    this.selectWidth.floor = this.selectWidth.floor < 250 ? 250 : this.selectWidth.floor;
                }
            },
            setDisplayStateFloor(visible) {
                this.$refs['selectFloorParent'].style.flex = visible ? 1 : 'none';
                if (this.$refs['filter-button'])
                    this.$refs['filter-button'].style.display = visible ? 'none' : null;
                if (this.$props.data.lotView === 'both')
                    this.$refs['widget-switch'].style.display = visible ? 'none' : null;
            },
            setDisplayStateTypo(visible) {
                this.$refs['selectTypoParent'].style.flex = visible ? 1 : 'none';
                if (this.$refs['filter-button'])
                    this.$refs['filter-button'].style.display = visible ? 'none' : null;
                if (this.$props.data.lotView === 'both')
                    this.$refs['widget-switch'].style.display = visible ? 'none' : null;
            },
            openFloorSelect() {
                this.selectOpenStatus.floor = !this.selectOpenStatus.floor;
                let mobile = window.matchMedia("(max-width: 515px)");
                if (mobile.matches) {
                    this.setDisplayStateFloor(this.selectOpenStatus.floor);
                    if (!this.selectOpenStatus.floor) {
                        this.closeFloorSelect();
                    } else
                        this.$refs['selectFloorParent'].style.flex = 1;
                }
            },
            closeFloorSelect() {
                this.$refs['selectFloorParent'].style.flex = null;
                if (this.selectOpenStatus.floor) {
                    this.selectOpenStatus.floor = false;
                    this.setDisplayStateFloor(this.selectOpenStatus.floor);
                }
            },
            selectFloor(floor) {
                this.getCurrentFloor(floor);
                this.resetSearch();
                this.applyFilters();
            },
            resetFilters() {
                this.$props.data.filters = _.cloneDeep(this.defaultFilters);
                this.resetSliders();
                this.resetSearch();
                this.applyFilters();
                EventBus.$emit('updateSidebar', this.$props.data, false);
            },
            resetSliders() {
                EventBus.$emit('resetSliders');
            },
            filterByPrice(min, max) {
                if (!this.$props.data.filters.userPriceInterval)
                    this.$props.data.filters.userPriceInterval = {min: 0, max: 0};

                this.$props.data.filters.userPriceInterval.min = min;
                this.$props.data.filters.userPriceInterval.max = max;
                this.resetSearch();
                this.trackingEventSearching();
                this.applyFilters();
            },
            filterByFloor(floor) {
                this.closeFloorSelect();
                this.trackingEventSearching();
                this.$props.data.floors.filter(el => el.active).forEach(el => el.active = false);
                this.$props.data.floors.filter(el => el.id === floor.id)[0].active = true;
                this.resetSearch();
                EventBus.$emit('updateCutawayData', floor);
            },
            filterByMultiFloor(floor) {
                this.$set(floor, 'active', !floor.active ? true : false);
                this.resetSearch();

                this.trackingEventSearching();
                EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
            },
            filterByTypology(typology) {
                typology.active = !typology.active;
                this.resetSearch();
                this.trackingEventSearching();
                EventBus.$emit('3d_FilterHotspot');
                EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
            },
            switchWidget(widget) {
                this.getMaxWidth();
                this.widget = widget;
                EventBus.$emit('updateLoadedWidgets', {
                    id: this.widget,
                    link: this.apiUrl + '/request-data/cutaway-view' + window.location.search,
                    active: true,
                    widgetType: this.widget
                });
            },
            handler() {
                this.sidebarHeight = this.$refs['sidebar-header'] ? window.innerHeight - this.$refs['sidebar-header'].$el.clientHeight : window.innerHeight;
                let sidebarDOMElement = document.getElementById('sidebar-content');
                this.scrollValue = sidebarDOMElement.scrollTop;
                this.scrollMax = sidebarDOMElement.scrollHeight - sidebarDOMElement.clientHeight;
                this.getMaxWidth();
            },
            toggleMenu() {
                EventBus.$emit('toggleSidebar');
            },
            filterFavorite() {
                this.$props.data.filters.isFavorite = !this.$props.data.filters.isFavorite;
                this.$props.data.filters.enableFavorite = [];
                if (this.$props.data.filters.isFavorite) {
                    this.$props.data.floors.forEach(floor => {
                        floor.hotspots.forEach(hotspot => {
                            if (hotspot.link) {
                                let url = new URL(hotspot.link);
                                let plotId = url.searchParams.get('id');
                                if (plotId !== null && this.favoriteList.includes(plotId))
                                    if (!this.$props.data.filters.enableFavorite.includes(hotspot.name))
                                        this.$props.data.filters.enableFavorite.push(hotspot.name);
                            }
                        });
                    });
                    this.setDisplayFavorite(true);

                    if (this.$props.data.type === 'cutaway' && this.$props.data.lotView === 'both') {
                        this.toggleWidget('plot-grid');
                        this.lastWidget = 'cutaway';
                    }
                } else {
                    this.$props.data.floors.forEach(floor => {
                        floor.hotspots.forEach(hotspot => {
                            if (!this.$props.data.filters.enableFavorite.includes(hotspot.name))
                                this.$props.data.filters.enableFavorite.push(hotspot.name);
                        });
                    });
                    if (this.lastWidget) {
                        this.toggleWidget(this.lastWidget);
                        this.lastWidget = null;
                    }

                    this.setDisplayFavorite(false);
                }
                this.resetSearch();
                EventBus.$emit('updateSidebar', this.$props.data, false);
                this.trackingEventSearching();
                this.applyFilters();
            },
            toggleWidget(widget) {
                EventBus.$emit('updateLoadedWidgets', {
                    id: widget,
                    link: this.apiUrl  + '/request-data/cutaway-view' + window.location.search,
                    active: true,
                    widgetType: widget
                });
                this.switchWidget(widget);
            },
            getPlotAvailabilityList(hotspotList) {
                if (hotspotList.length > 0) {
                    let availabilityList = {};
                    let currentAvailability = null;
                    let tmpAvailabilityList = {};
                    hotspotList.forEach((hotspot) => {
                        currentAvailability = this.getKeyValue('availability', hotspot);
                        if (currentAvailability !== null)
                            if (tmpAvailabilityList[currentAvailability])
                                tmpAvailabilityList[currentAvailability]['count'] += 1;
                            else {
                                tmpAvailabilityList[currentAvailability] = {count: 1, color: hotspot.color, active: true};
                            }
                    });

                    //Sort by availability text
                    Object.keys(tmpAvailabilityList).sort().forEach((key) => {
                        availabilityList[key] = tmpAvailabilityList[key];
                    });

                    return availabilityList;
                } else
                    return {};
            },
            filterByAvailability(availability) {
                availability.active = !availability.active;
                this.resetSearch();
                this.trackingEventSearching();
                this.applyFilters();
                EventBus.$emit('updateSidebar', this.$props.data, false);
            },
            trackingEventSearching(){
                let event = 'searching';
                let trackingData = this.$props.data.tracking;
                if (!this.clickedTracking) {
                    this.clickedTracking = true;
                    EventBus.$emit('trackingEvent', trackingData, event);
                    setTimeout(() => {
                        this.clickedTracking = false;
                    }, 10000);
                }
            },
            filterTag(currentTag) {
                this.$props.data.filters.tags.filter(tag => tag.id === currentTag.id)[0].active = !currentTag.active;
                this.resetSearch();
                this.trackingEventSearching();
                EventBus.$emit('3d_FilterHotspot', this.$props.data.filters);
                EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
                EventBus.$emit('updateSidebar', this.$props.data, false);
            },
            applyFilters() {
                if (this.$props.data.lotView === 'both') {
                    EventBus.$emit('3d_FilterHotspot', this.$props.data.filters);
                    EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
                } else if (this.$props.data.lotView === '3d')
                    EventBus.$emit('3d_FilterHotspot', this.$props.data.filters);
                else
                    EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
            },
            getCurrentFloor(floor){
                this.$props.data.floors.filter(el => el.active).forEach(el => el.active = false);
                this.$props.data.floors.filter(el => el.id === floor.id)[0].active = true;
                EventBus.$emit('updateCutawayData', floor);
            },
            resetSearch() {
                this.$props.data.filters.searchValue = null;
                this.inputSearch = '';
                this.$refs.autocomplete.value = '';
                this.applyFilters();
            },
            search(input) {
                let hotspotList = [];
                this.inputSearch = input;
                if (input.length < 1) {
                    return []
                }

                this.$props.data.floors.forEach(floor => {
                    floor.hotspots.forEach(hotspot => {
                        if (hotspot.name !== null && !hotspotList.includes(hotspot.name))
                            hotspotList.push(hotspot.name)
                    })
                });
                return hotspotList.filter(hotspot => {
                    return hotspot.toLowerCase().includes(input.toLowerCase());
                }).slice(0, 10);
            },
            searchSubmit(){
                this.$props.data.floors.forEach(floor=> {
                    floor.hotspots.forEach(hotspot => {
                        if (hotspot.name === this.$refs.autocomplete.value){
                            this.getCurrentFloor(floor);
                            this.$props.data.filters.searchValue = this.$refs.autocomplete.value
                        }
                    });
                });
                this.applyFilters()
            },
            hideTooltips() {
                let tooltipKeys = [];
                for (const [key, value] of Object.entries(this.showTooltip)) {
                    if (value == true)
                        tooltipKeys.push(key);
                }

                tooltipKeys.forEach(key => {
                    this.showTooltip[key] = false;
                });
            },
            scrollToTop() {
                this.sidebarHeight = window.innerHeight - this.$refs['sidebar-header'].$el.clientHeight;
                TweenLite.to(
                    document.getElementById('sidebar-content'),
                    .5,
                    {
                        scrollTop: 0
                    }
                );
            },
            scrollToBottom() {
                this.sidebarHeight = window.innerHeight - this.$refs['sidebar-header'].$el.clientHeight;
                let sidebarDOMElement = document.getElementById('info-prog-content');
                let maxScrollTop = sidebarDOMElement.scrollHeight - sidebarDOMElement.clientHeight;
                TweenLite.to(
                    document.getElementById('sidebar-content'),
                    .5,
                    {
                        scrollTop: maxScrollTop
                    }
                );
            },
            onScroll(e) {
                this.sidebarHeight = window.innerHeight - this.$refs['sidebar-header'].$el.clientHeight;
                this.scrollValue = e.target.scrollTop;
            },
            filterByArea(min, max) {
                if (!this.$props.data.filters.userAreaInterval)
                    this.$props.data.filters.userAreaInterval = {min: 0, max: 0};

                this.$props.data.filters.userAreaInterval.min = min;
                this.$props.data.filters.userAreaInterval.max = max;
                this.resetSearch();
                this.trackingEventSearching();
                this.applyFilters();
            },
        },
        watch: {
            showTooltip: {
                handler() {
                    if (this.tooltipTimeout)
                        window.clearTimeout(this.tooltipTimeout);

                    this.tooltipTimeout = window.setTimeout(() => {
                        this.hideTooltips();
                    }, this.tooltipDuration);
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/autocomplete.scss";
    @import "@/assets/scss/components/_tags.scss";
</style>


// WEBPACK FOOTER //
// src/components/navbarLayout/alternativeMenu/CutawayLayout.vue